import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, ArrowRight } from "lucide-react";

/**
 * PrevNextNav — chronological sequential reading like a long-form magazine.
 * Both slots optional — renders whatever is available.
 */
export function PrevNextNav({ prev, next }) {
  if (!prev && !next) return null;
  return (
    <nav
      aria-label="Article navigation"
      className="mt-14 pt-10 border-t border-[#E5E7EB] grid grid-cols-1 md:grid-cols-2 gap-5"
      data-testid="blog-prev-next"
    >
      {prev ? (
        <Link
          to={`/blog/${prev.slug}`}
          data-testid="prev-article"
          className="group rounded-2xl border border-[#E5E7EB] bg-white p-6 hover:border-[#0A2540] transition-colors"
        >
          <div className="flex items-center gap-2 text-xs uppercase tracking-wider text-[#6B7280] mb-3">
            <ArrowLeft className="w-3.5 h-3.5" /> Previous article
          </div>
          <div className="text-[11px] uppercase tracking-wider text-[#0066FF] font-medium mb-1.5">
            {prev.category}
          </div>
          <h3 className="font-display text-lg text-[#0A2540] font-semibold leading-snug group-hover:text-[#0066FF] transition-colors line-clamp-3">
            {prev.title}
          </h3>
        </Link>
      ) : (
        <div className="hidden md:block" aria-hidden="true" />
      )}
      {next ? (
        <Link
          to={`/blog/${next.slug}`}
          data-testid="next-article"
          className="group rounded-2xl border border-[#E5E7EB] bg-white p-6 hover:border-[#0A2540] transition-colors md:text-right"
        >
          <div className="flex md:justify-end items-center gap-2 text-xs uppercase tracking-wider text-[#6B7280] mb-3">
            Next article <ArrowRight className="w-3.5 h-3.5" />
          </div>
          <div className="text-[11px] uppercase tracking-wider text-[#0066FF] font-medium mb-1.5">
            {next.category}
          </div>
          <h3 className="font-display text-lg text-[#0A2540] font-semibold leading-snug group-hover:text-[#0066FF] transition-colors line-clamp-3">
            {next.title}
          </h3>
        </Link>
      ) : (
        <div className="hidden md:block" aria-hidden="true" />
      )}
    </nav>
  );
}
